import { createFileRoute, redirect } from '@tanstack/react-router'
import { EmployeeOnboarding } from '@/features/hr-employees/onboarding/employee-onboarding'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for creating an employee: the onboarding wizard (f442), which
 * replaced the one-page form of design 1e.
 *
 * `employees.new` rather than `employees/$employeeId` with a sentinel id: a
 * create form and an edit form differ in what they may send, and a route that
 * has to ask "is this id real" is a route that will one day be given a real
 * employee called `new`.
 */
export const Route = createFileRoute('/_authenticated/hr/employees/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'employee.create')) {
      throw redirect({ to: '/hr/employees' })
    }
  },
  component: NewEmployeeRoute,
})

function NewEmployeeRoute() {
  return <EmployeeOnboarding />
}
